import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { TOKENS } from '../state/colors';
import { fs } from '../state/typography';

interface SectionCardProps {
  title: string;
  children: ReactNode;
}

// SPEC-105 (CH-01, RN-003) — wrapper visual de sección compartido por las 3 pestañas del
// Centro de Cotizaciones. KpiStrip queda excluido a propósito: sus 4 cards ya cumplen esa
// función y envolverlas de nuevo duplicaría el marco visual (RN-003).
export const SectionCard: React.FC<SectionCardProps> = ({ title, children }) => {
  return (
    <Box
      component="section"
      data-testid="section-card"
      sx={{
        backgroundColor: '#fff',
        border: `1px solid ${TOKENS.hair}`,
        borderRadius: '20px',
        padding: '26px 28px',
        marginBottom: '26px',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,.65), 0 2px 4px rgba(46,36,48,.06), 0 14px 30px rgba(46,36,48,.12)',
        '& > :last-child': { marginBottom: 0 },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
        <Box sx={{ width: 6, height: 6, borderRadius: '2px', backgroundColor: TOKENS.purple, flexShrink: 0 }} />
        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: fs(11),
            fontWeight: 700,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            color: TOKENS.muted,
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </Typography>
        <Box sx={{ flex: 1, height: '1px', backgroundColor: TOKENS.hair }} />
      </Box>
      {children}
    </Box>
  );
};
